// Check URL
export function isSameDomain(data, widgetName) {
  const clientPath = SITEBASEURL;
  $(`#${widgetName}`)
    .find('.card-widget-item')
    .each(function (x) {
      const { URL } = data.items[x];
      const $cardItem = $(this);

      if (URL) {
        const isSame = URL.startsWith(clientPath);
        if (isSame) {
          $cardItem.removeAttr('target');
        } else {
          $cardItem.attr('target', '_blank');
        }
      }
    });
}

// multi theming
function validateEntireSubpageTheme(subpageClass) {
  return $('body').hasClass(subpageClass);
}

function validateLandingPage(homeClass) {
  return $('body').hasClass(homeClass);
}

function validateSubPage(homeClass, subpageClass) {
  return $('body').hasClass(subpageClass) && !$('body').hasClass(homeClass);
}

const storage = globalThis.sessionStorage;
let location = globalThis.location.pathname;

function applyThemeClass(theme) {
  storage.setItem('subPage', true);
  storage.setItem('subpageName', theme);
}

function addSubThemeToSaffirePages() {
  if (!location.includes(themesConfig[0].navItemUrl)) {
    $('body').addClass(storage.getItem('subpageName'));
  }
}

function showContent(themeClass) {
  setTimeout(() => {
    $(`.${themeClass}`).css('opacity', 1);
  }, 1000);
}

function checkWindowsSize(pixels) {
  return $(globalThis).width() <= pixels;
}

function validateVideoStatus(videoId, placeholderId) {
  const video = document.getElementById(videoId);

  video.play().catch((error) => {
    console.error('Error trying to play video:', error);
  });

  setTimeout(() => {
    const isPlaying = video.readyState >= 3 && !video.paused && !video.ended;

    if (isPlaying) {
      $(`#${placeholderId}`).css('opacity', '0');
      $(`#${videoId}`).css('opacity', '1');
      $(`#${videoId}`).attr('controls', true);
      $(`#${videoId}`).removeAttr('muted playsinline');

      $(`#${placeholderId}`).css('z-index', '-1');
    }
  }, 3000);
}

function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');
  }
}

function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 1100px)');
    const additionalValue = mq.matches ? 10 : 40;
    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage') || $('body').hasClass('fairgrounds-homepage');
    const hasHero = $('body').hasClass('has-hero');
    const isSubthemePage =
      $('body').hasClass('fairgrounds-subtheme') && !$('body').hasClass('fairgrounds-homepage');

    if (isHomepage) {
      content.css('margin-top', `${headerHeight}px`);
    } else if (hasHero) {
      content.css('margin-top', `0px`);
      $('.subpage-hero').css('margin-top', `${headerHeight}px`);
    } else if (isSubthemePage) {
      content.css('margin-top', `${headerHeight + 30}px`);
    } else {
      content.css('margin-top', `${headerHeight + additionalValue}px`);
    }
  }
  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });
}

export {
  validateEntireSubpageTheme,
  validateLandingPage,
  validateSubPage,
  applyThemeClass,
  addSubThemeToSaffirePages,
  storage,
  showContent,
  checkWindowsSize,
  validateVideoStatus,
  headerSearchBarFix,
  updateContentMargin,
};
